import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HomeCard from '../HomeCard/HomeCard';
import './HomeSection.css';

import trainingIcon from '../../images/icons/training.svg';
import supportIcon from '../../images/icons/support.svg';
import devIcon from '../../images/icons/dev.svg';
import consultIcon from '../../images/icons/consult.svg';
import LogoCardSection from '../LogoCardSection/LogoCardSection';
import Contact from '../Contact/Contact';
import HowWeWork from '../HowWeWork/HowWeWork';
import BusinessCategories from '../BusinessCategories/BusinessCategories';
import WhyChooseLucods from '../WhyChooseLucods/WhyChooseLucods';
import BusinessProblems from '../BusinessProblems/BusinessProblems';
import { useLanguage } from '../../context/LanguageContext';

const HomeSection: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    // Force canvas reinitialization when component mounts
    const event = new Event('resize');
    window.dispatchEvent(event);
  }, []);

  const cards = [
    {
      title: t('home.consulting.title'),
      text: t('home.consulting.text'),
      icon: consultIcon
    },
    {
      title: t('home.development.title'),
      text: t('home.development.text'),
      icon: devIcon
    },
    {
      title: t('home.training.title'),
      text: t('home.training.text'),
      icon: trainingIcon
    },
    {
      title: t('home.support.title'),
      text: t('home.support.text'),
      icon: supportIcon
    },
  ];

  return (
    <section className="home-section">
      {/* Section 0: Business Problems */}
      <div id="problems-section">
        <BusinessProblems />
      </div>

      {/* Section 1: What's included in service (3 cards) */}
      <div id="services-section">
        <Container fluid="lg">
          <div className="section-header mb-5">
            <h2 className="section-title">Así transformamos tu negocio</h2>
          <Row className="g-4 justify-content-center">
            {cards.map((card, index) => (
              <Col key={index} xs={12} sm={6} lg={3} className="d-flex justify-content-center">
                <HomeCard title={card.title} text={card.text} icon={card.icon} />
              </Col>
            ))}
          </Row>
        </div>
      </Container>
      </div>

      {/* Section 2: How we work (4 steps) */}
      <div id="how-we-work-section">
        <HowWeWork />
      </div>

      {/* Section 3: Social proof (client logos) */}
      <div id="clientes-section">
        <LogoCardSection />
      </div>

      {/* Section 4: Is this service for you? (3 business categories) */}
      <div id="categories-section">
        <BusinessCategories />
      </div>

      {/* Section 5: Why choose Lucods */}
      <div id="why-lucods-section">
        <WhyChooseLucods />
      </div>

      {/* Section 6: Contact form */}
      <div id="contact-section">
        <Contact />
      </div>
    </section>
  );
};

export default HomeSection;

